module.exports = __webpack_public_path__ + "img/Equipa_Sinal_2.dd5d2edf.png";